import httpAuth from "../common/http/http-common";
import { VacancyApplicantNoteFormDto, VacancyDetailsDto, VacancyDto, VacancyFormDataDto, VacancyFormDto } from "@/types/vacancy.type";

class VacancyService {
  client = httpAuth("vacancy");

  async getDetailsAsync(id: number, practiceId: number): Promise<VacancyDetailsDto> {
    const { data } = await this.client.get(`${id}/practice/${practiceId}/details`);

    return data;
  }

  async getByPracticeAsync(practiceId: number): Promise<VacancyDto[]> {
    const { data } = await this.client.get(`practice/${practiceId}`);

    return data;
  }

  async getFormAsync(id: number): Promise<VacancyFormDto> {
    const { data } = await this.client.get(`${id}/form`);

    return data;
  }

  async getFormDataAsync(practiceId: number): Promise<VacancyFormDataDto> {
    const { data } = await this.client.get(`practice/${practiceId}/form/data`);

    return data;
  }

  async deleteAsync(id: number): Promise<void> {
    await this.client.delete(`${id}`);
  }

  async updateInterestAsync(id: number, userId: number, isInterested: boolean | null = null): Promise<void> {
    await this.client.put(`${id}/user/${userId}/interest`, isInterested);
  }

  async updateFillAsync(id: number): Promise<void> {
    await this.client.put(`${id}/fill`);
  }

  async updateHireAsync(id: number, userId: number): Promise<void> {
    await this.client.put(`${id}/user/${userId}/hire`);
  }

  async saveAsync(form: VacancyFormDto): Promise<void> {
    await this.client.put(".", form);
  }

  async saveNoteAsync(form: VacancyApplicantNoteFormDto): Promise<void> {
    await this.client.put("note", form);
  }

  async deleteNoteAsync(noteId: number): Promise<void> {
    await this.client.delete(`note/${noteId}`);
  }
}

export default new VacancyService();